export const VISIBLE_CHARS = 5;

export const hideApiKeyPart = apiKey => {
  if (!apiKey) {
    return '';
  }

  return `${apiKey.slice(0, VISIBLE_CHARS)}**********************`;
};
